import React from 'react';
import ProductsList from '../Components/Products/ProductsList';

export default function Store() {
  return (
    <div>
      <ProductsList />
    </div>
  );
}
